import { forwardRef, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, className = "", ...props }, ref) => {
    // Derived from the field's own id: a page can show several errors at once,
    // and a shared literal id would collide and mis-associate the message.
    const errorId = props.id ? `${props.id}-error` : "input-error";
    return (
    <div className="w-full">
      <input
        ref={ref}
        className={
          "w-full box-border h-[var(--spacing-touch)] min-h-[var(--spacing-touch)] shrink-0 overflow-hidden " +
          "px-3 py-0 text-base leading-5 rounded-[var(--radius-md)] bg-[var(--color-surface-elevated)] border text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)] " +
          "focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:border-transparent " +
          (error
            ? "border-[var(--color-danger)] focus:ring-[var(--color-danger)]"
            : "border-[var(--color-border)]") +
          (className ? " " + className : "")
        }
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-[var(--color-danger)]">
          {error}
        </p>
      )}
    </div>
    );
  }
);

Input.displayName = "Input";
